// @flow
import {
  useCallback,
} from 'react';
import {
  useSelector,
} from 'react-redux';
import {
  getStatus as getResourceStatus,
} from 'redux-resource';

import type {
  StatelessFunctionalComponent,
  Node,
} from 'react';


type Props = {
  pending: boolean,
  render: (pending: boolean) => Node,
  resourceType: string,
  request: string,
}

const mapState = (state, props) => ({
  pending:
    (props.resourceType && props.request)
      ? getResourceStatus(
        state,
        `${props.resourceType}.requests.${props.request}.status`,
        true,
      ).pending
      : false,
});

const FlagHoc: StatelessFunctionalComponent<Props> = ({
  render,
  resourceType,
  request,
}: Props): Node => {
  const mapStateMemoized = useCallback(
    state => mapState(
      state,
      {
        resourceType,
        request,
      },
    ),
    [`${resourceType}_${request}`],
  );
  const { pending } = useSelector(mapStateMemoized);
  return render(pending);
};

export default FlagHoc;
